import React from "react"
import { IAgentLayoutProps } from "./util"
import { Carousel } from "../Carousel/Carousel"
import { EListingCardLayouts, ListingCard } from "../Listing/ListingCard"
import { BackgroundImage } from "../Media/BackgroundImage"
import TabbedContentBlade, { ITabContent } from "../Blades/TabbedContentBlade"
import { IAgent } from "../../lib/Contact/types"
import ContactCard from "./ContactCard"
import { ContactForm } from "../Forms"
import Testimonials from "../Blades/Testimonials"
import Slider from "react-slick"
import { WsrvImage } from "../Media"
import { EWsrvTransform } from "../../lib/Media/util"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";


export const AgentLayoutTabs: React.FC<IAgentLayoutProps> = ({
    className = "",
    agent,
    linkFunc,
    showCarousel,
    listings,
    useHeroImage,
    heroImage,
    heroCaption,
    carouselProps,
    requestInfoFormProps,
    testimonialsProps,
    tabsListingCardVitalsLayout,
    listingsSliderProps,
    linkedPosts,
}) => {
    const PrevArrow = (props: any) => {
        return (
            <button
                {...props}
                className={`z-10 absolute left-0 top-1/2 cursor-pointer text-white bg-[#333333] h-[40px] w-[40px] rounded-full !flex flex-col justify-center items-center ${props.classNames}`}
            >
                <FiChevronLeft />
            </button>
        )
    }
    const NextArrow = (props: any) => {
        return (
            <button
                {...props}
                className={`z-10 absolute right-0 top-1/2 cursor-pointer text-white bg-[#333333] h-[40px] w-[40px] rounded-full !flex flex-col justify-center items-center ${props.classNames}`}
            >
                <FiChevronRight />
            </button>
        )
    }

    const TabsSection = (agent: IAgent) => {
        let tabContent: ITabContent[] = [
            {
                tabTitle: "About Me",
                contentClassName: "max-w-full",
                content: (
                    <div className="w-full flex flex-row flex-wrap">
                        <div className="flex flex-col w-full lg:w-1/2 p-2 min-h-[480px] inverted self-stretch">
                            <div className="p-5 h-full w-full text-sm border grow" dangerouslySetInnerHTML={{ __html: agent.bio ?? "" }}></div>
                        </div>
                        <div className="w-full lg:w-1/2 px-1">
                            <div className="flex flex-col w-full border">
                                <ContactCard
                                    className="w-full"
                                    contact={agent}
                                    linkFunc={linkFunc}
                                    imageClasses="px-4 pb-4 pt-2.5"
                                />
                                <div className="block mx-4 h-px border-t mt-1 mb-5"></div>
                                <ContactForm
                                    classNames="strictTwoColumn"
                                    mainLegendClassName="!py-0 md:!pt-0 !text-left"
                                    fieldsetClassName="!px-4"
                                    mainListClassName="!max-w-full w-full !my-2 !gap-y-2"
                                    inputTextAreaLabel="Message"
                                    inputTextClassNames="!text-sm"
                                    inputTextAreaClassName="!text-sm"
                                    submitButtonClassName="bg-button-bg-inverted text-button-text-inverted text-sm border-0 !w-40"
                                    hideReCaptchaText={true}
                                    {...requestInfoFormProps}
                                />
                            </div>
                        </div>
                    </div>
                ),
            }
        ];
        agent.profile && tabContent.push({
            tabTitle: "Experience",
            contentClassName: "w-full max-w-full",
            content: (
                <div className="w-full inverted p-2">
                    <div className="border px-10 py-2.5 text-sm" dangerouslySetInnerHTML={{ __html: agent.profile }}>
                    </div>
                </div>
            )
        });
        linkedPosts?.[0] && tabContent.push({
            tabTitle: "News",
            contentClassName: "w-full max-w-full",
            content: (
                <div className="w-full inverted p-2">
                    <div className="border px-10 py-2.5 flex flex-col gap-y-5 w-full">
                        {linkedPosts.map((p: any, i: number) => (
                            <>
                                {linkFunc && (linkFunc({ key: i, href: p.href, children: p.text }))}
                            </>
                        ))}
                    </div>
                </div>
            )
        })
        testimonialsProps && testimonialsProps?.testimonials?.[0] && tabContent.push({
            tabTitle: "Testimonials",
            contentClassName: "w-full max-w-full",
            content: (
                <div className="w-full">
                    <Testimonials
                        leftColumn={<></>}
                        leftColumnClass="hidden"
                        rightColumnClass="!w-full border py-5"
                        testimonialTextClass="px-16 w-full"
                        dividerClass="hidden"
                        showAttribution={true}
                        attributionClass="text-right pl-16 pr-20"
                        showQuotes={false}
                        className="inverted w-full !p-2 text-sm"
                        columnsWrapperClass="w-full"
                        slickSettings={{
                            dots: false,
                            nextArrow: <NextArrow classNames="!top-0 !right-2.5" />,
                            prevArrow: <PrevArrow classNames="!top-0 !left-2.5" />
                        }}
                        {...testimonialsProps}
                    />
                </div>
            )
        });

        return (
            <TabbedContentBlade
                className="max-w-screen-xl mx-auto mt-7"
                tabListClassName="gap-x-5 lg:gap-x-14 mb-8"
                tabListItemClassNames={{
                    default: "!w-auto md:!w-auto lg:!w-auto",
                    active: "!w-auto md:!w-auto lg:!w-auto border-b border-body-bg-inverted"
                }}
                tabs={tabContent}
            />
        );
    }

    const slickSliderClasses = "[&_.slick-slide]:md:!w-1/2 [&_.slick-slide]:lg:!w-1/3 [&_.slick-slide]:!px-3.5";

    return (
        <div className={`${className} agent-layout my-0 mx-auto`}>
            {!useHeroImage && showCarousel && listings?.active?.[0] && (
                <div className="relative w-full">
                    <Carousel
                        {...carouselProps}
                    >
                        {listings.active.length > 1 && listings.active.filter((l) => l.defaultImage && l.defaultImage.url).map((img, index) => (
                            <WsrvImage
                                key={index}
                                urlParams={{
                                    originURL: img.defaultImage?.url ?? "",
                                    preset: EWsrvTransform.cover4x3,
                                    width: 2400
                                }}
                                imgProps={{
                                    className:
                                        "w-full h-auto lg:h-full object-cover object-center aspect-[4/3] md:aspect-auto",
                                    wrapperClassName: "block w-full h-screen max-h-screen",
                                    wrapperProps: {
                                        style: { display: "block" }
                                    }
                                }}
                            />
                        ))}
                        {listings.active.length == 1 && listings.active[0].images && listings.active[0].images.map((img, index) => (
                            <WsrvImage
                                key={index}
                                urlParams={{
                                    originURL: img.url,
                                    preset: EWsrvTransform.cover4x3,
                                    width: 2400
                                }}
                                imgProps={{
                                    className:
                                        "w-full h-auto lg:h-full object-cover object-center aspect-[4/3] md:aspect-auto",
                                    wrapperClassName: "block w-full lg:h-screen lg:max-h-screen",
                                    wrapperProps: {
                                        style: { display: "block" }
                                    }
                                }}
                            />
                        ))}
                    </Carousel>
                    <h1 className="absolute bottom-0 inset-x-0 z-10 text-composite-text block w-full max-w-screen-xl mx-auto text-left text-6xl mb-11 px-5">{heroCaption ?? agent.fullName}</h1>
                </div>
            )}
            {useHeroImage && heroImage?.url && (
                <BackgroundImage
                    src={heroImage.url}
                    className="w-full h-screen max-h-screen flex flex-col justify-end"
                    children={(
                        <>
                            {<h1 className="text-composite-text block w-full max-w-screen-xl mx-auto text-left text-6xl mb-11 px-5">{heroCaption ?? agent.fullName}</h1>}
                        </>
                    )}
                />
            )}
            {TabsSection(agent)}
            {agent.funFacts && agent.funFacts?.[0] && (
                <div className="fun-facts relative w-full mt-10">
                    <div className="w-full mx-auto max-w-screen-xl flex flex-col items-center px-7 md:px-2">
                        <h2 className="text-center pt-4 pb-1">Fun Facts<span className="block">About Me</span></h2>
                        <div className="w-full grid grid-cols-1 md:grid-cols-3 md:gap-x-7 py-4">
                            {agent.funFacts.map((f, index, array) => (
                                <div key={index} className={`${index <= (array.length - 2) ? "border-b" : ""} ${index >= 3 ? "md:border-b-0" : ""} py-5`}>
                                    <div className="text-lg">{f.headline}</div>
                                    <div className="text-sm pt-2.5">{f.funFact}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {listings?.active?.[0] && (
                <div className="max-w-screen-xl mx-auto w-full">
                    <h2 className="text-center pt-8 pb-6">Featured<span className="block">Listings</span></h2>
                    <Slider
                        className={`w-full ${slickSliderClasses} `}
                        slidesToShow={listings.active.length < 3 ? listings.active.length : 3}
                        slidesToScroll={1}
                        arrows={true}
                        nextArrow={<NextArrow />}
                        prevArrow={<PrevArrow />}
                        responsive={[
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: listings.active.length < 2 ? listings.active.length : 2
                                },
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]}
                        {...listingsSliderProps}
                    >
                        {listings.active.map((listing, index) => (
                            <ListingCard
                                key={index}
                                listing={listing}
                                layout={EListingCardLayouts.vertical}
                                linkFunc={linkFunc}
                                {...tabsListingCardVitalsLayout}
                            />
                        ))}
                    </Slider>
                </div>
            )}
            {listings?.sold?.[0] && (
                <div className="max-w-screen-xl mx-auto w-full">
                    <h2 className="text-center pt-8 pb-6">Sold<span className="block">Listings</span></h2>
                    <Slider
                        className={`w-full ${slickSliderClasses}`}
                        slidesToShow={listings.sold.length < 3 ? listings.sold.length : 3}
                        slidesToScroll={1}
                        arrows={true}
                        nextArrow={<NextArrow />}
                        prevArrow={<PrevArrow />}
                        responsive={[
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: listings.sold.length < 2 ? listings.sold.length : 2
                                },
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]}
                        {...listingsSliderProps}
                    >
                        {listings.sold.map((listing, index) => (
                            <ListingCard
                                key={index}
                                listing={listing}
                                layout={EListingCardLayouts.vertical}
                                linkFunc={linkFunc}
                                {...tabsListingCardVitalsLayout}
                            />
                        ))}
                    </Slider>
                </div>
            )}
        </div>
    )
}

export default AgentLayoutTabs